<template>
  <div class="tq-person-selector-choose">
    <el-scrollbar
      height="530px"
      class="tq-person-selector-choose-scrollbar"
      v-loading="hookData.loading"
    >
      <checkbox-radio
        v-model="hookData.selectedCodes"
        :multiple="multiple"
        :data="hookData.personList"
      ></checkbox-radio>
      <Empty
        v-if="!hookData.personList.length && !hookData.loading"
        text="暂无数据"
      ></Empty>
    </el-scrollbar>
  </div>
</template>

<script lang="ts" setup>
import Empty from "./Empty.vue";
import checkboxRadio from "./checkboxRadio.vue";
import { inject } from "vue";
import { hookData } from "../hooks/index";

const multiple = inject<boolean>("multiple")!;
</script>

<style scoped>
.tq-person-selector-choose {
  padding-left: 20px;
}
</style>
